import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import TwoStepVerification from './twoStepVerification';
import Password from './password';

function Security (props) {
    const {
        onSavePassword,
        isFederated,
    } = props;

    return (
        <React.Fragment>
            <TwoStepVerification />
            <Password
                isFederated={isFederated}
                onSavePassword={onSavePassword}
            />
        </React.Fragment>
    );
}

Security.propTypes = {
    onSavePassword: PropTypes.func,
    isFederated: PropTypes.bool,
};

Security.defaultProps = {
    isFederated: false,
    onSavePassword: () => { },
};

export default observer(Security);
